// $ASSA on-chain identity — Base mainnet (chain 8453). Public + Basescan-verified.
// Address is fixed/public; VITE_ override kept for parity with other site config.
export const ASSA_TOKEN = {
  address:
    (import.meta.env.VITE_ASSA_ADDRESS as string | undefined) ??
    "0xA35BE42FF121F1D6333dd15bb2f5524A7BD684a6",
  symbol: "ASSA",
  decimals: 18,
  chainId: 8453,
  // PNG (not SVG): MetaMask renders wallet_watchAsset images reliably only as raster.
  image: "https://assawave.io/brand/assa-icon-256.png",
} as const;

// EIP-3085 params, used to add Base if the wallet doesn't have it yet.
export const BASE_CHAIN = {
  chainIdHex: "0x2105", // 8453
  chainName: "Base",
  nativeCurrency: { name: "Ether", symbol: "ETH", decimals: 18 },
  rpcUrls: ["https://mainnet.base.org"],
  blockExplorerUrls: ["https://basescan.org"],
} as const;

export const ASSA_BASESCAN = `https://basescan.org/token/${ASSA_TOKEN.address}`;
